// extracted by mini-css-extract-plugin
export default {"calendar":"index_calendar_Tx5go"};